module.exports = __webpack_public_path__ + "img/plein soleil.296e93f0.png";